import { CALENDLY_CONTACT_URL } from './social';

export const ROUTE_ROOT = '/';
export const ROUTE_HOME = '/home';
export const ROUTE_AUTH_ROOT = '/auth';
export const ROUTE_DASHBOARD_ROOT = '/dashboard';
export const ROUTE_ACCOUNT_MANAGEMENT_ROOT = '/account-management';
export const ROUTE_SETTING_ROOT = '/settings';
export const ROUTE_RECORDS_ROOT = '/records';
export const ROUTE_SEARCH_ROOT = '/search';
export const ROUTE_PLAN_USAGE_HUB_ROOT = '/plan-usage-hub';
export const ROUTE_PROFILE_ROOT = '/profile';
export const ROUTE_LINK_ROOT = '/links';
export const ROUTE_FILE_ROOT = '/files';
export const ROUTE_OWL = '/owl';
export const ROUTE_ENRICH_ROOT = '/enrich';
export const ROUTE_SETTING_DASHBOARD = `${ROUTE_SETTING_ROOT}${ROUTE_DASHBOARD_ROOT}`;
export const ROUTE_SETTING_ACCOUNT_MANAGEMENT = `${ROUTE_SETTING_ROOT}${ROUTE_ACCOUNT_MANAGEMENT_ROOT}`;
export const ROUTE_PLAN_USAGE_HUB = `${ROUTE_SETTING_ROOT}${ROUTE_PLAN_USAGE_HUB_ROOT}`;
export const ROUTE_PROFILE = `${ROUTE_SETTING_ROOT}${ROUTE_PROFILE_ROOT}`;
export const ROUTE_API_MANAGEMENT_ROOT = 'api-management';
const PERSONALITY_ANALYSIS = `personality-analysis`;

const supportUrl = CALENDLY_CONTACT_URL;

export const SHARED_ROUTES = {
  root: ROUTE_ROOT,

  // ******home*******
  home: ROUTE_HOME,

  // ******auth*******
  auth: ROUTE_AUTH_ROOT,

  // ******misc*******
  dashboard: ROUTE_DASHBOARD_ROOT,
  academyCenter: 'academy-center',
  support: supportUrl,

  // ******owl*******
  owl: ROUTE_OWL,
  personalityAnalysis: `${ROUTE_OWL}/${PERSONALITY_ANALYSIS}`,
  owlPersonalityAnalysisSingle: `${ROUTE_OWL}/${PERSONALITY_ANALYSIS}/single`,
  owlPersonalityAnalysisBulk: `${ROUTE_OWL}/${PERSONALITY_ANALYSIS}/bulk`,
  owlPersonalityAnalysisBulkMapping: `${ROUTE_OWL}/${PERSONALITY_ANALYSIS}/bulk/mapping`,
  owlDetail: `${ROUTE_OWL}/${PERSONALITY_ANALYSIS}/detail`,
  owlAnalysisDetail: `${ROUTE_OWL}/${PERSONALITY_ANALYSIS}/detail/:id`,
  owlAnalysisBulkResult: `${ROUTE_OWL}/${PERSONALITY_ANALYSIS}/bulk/result`,
  owlAnalysisBulkResultDetail: `${ROUTE_OWL}/${PERSONALITY_ANALYSIS}/bulk/result-detail/:id`,

  // ******search*******
  search: ROUTE_SEARCH_ROOT,

  // ******setting*******
  settings: ROUTE_SETTING_ROOT,
  planUsageHub: ROUTE_PLAN_USAGE_HUB,
  currentPlan: `${ROUTE_PLAN_USAGE_HUB}/current-plan`,
  creditUsage: `${ROUTE_PLAN_USAGE_HUB}/credit-usage`,
  billing: `${ROUTE_PLAN_USAGE_HUB}/billing`,
  priceAndPlan: `${ROUTE_PLAN_USAGE_HUB}/plans-and-pricing`,

  profile: ROUTE_PROFILE,
  userProfile: `${ROUTE_PROFILE}/my-profile`,
  teamManagement: `${ROUTE_PROFILE}/user-management`,
  inviteMember: `${ROUTE_SETTING_ROOT}/team-management/invite`,

  priceAndPlanSuccessDowngrade: `${ROUTE_PLAN_USAGE_HUB}/plans-and-pricing#successDowngrade`,
  priceAndPlanSuccessUpgrade: `${ROUTE_PLAN_USAGE_HUB}/plans-and-pricing#successUpgrade`,
  priceAndPlanSuccessFailure: `${ROUTE_PLAN_USAGE_HUB}/plans-and-pricing#failure`,
  billingStatusCancel: `${ROUTE_SETTING_ROOT}/billing-cancel`,
  billingStatusSuccess: `${ROUTE_SETTING_ROOT}/billing-success`,
  whiteLabelSettings: `${ROUTE_SETTING_ROOT}/white-label`,
  themeManagement: `${ROUTE_SETTING_ROOT}/white-label/theme-management`,
  dashboardSetting: ROUTE_SETTING_DASHBOARD,
  accountStats: `${ROUTE_SETTING_DASHBOARD}/account-stats`,
  financialStats: `${ROUTE_SETTING_DASHBOARD}/financial-stats`,
  worldMap: `${ROUTE_SETTING_DASHBOARD}/world-map`,
  accountManagementSetting: `${ROUTE_SETTING_ACCOUNT_MANAGEMENT}`,
  accountManagementUsers: `${ROUTE_SETTING_ACCOUNT_MANAGEMENT}/users`,
  accountManagementAccounts: `${ROUTE_SETTING_ACCOUNT_MANAGEMENT}/accounts`,
  accountManagementPermissionProfiles: `${ROUTE_SETTING_ACCOUNT_MANAGEMENT}/permission-profiles`,
  accountManagementPermissionProfilesSoftware: `${ROUTE_SETTING_ACCOUNT_MANAGEMENT}/permission-profiles/software`,
  accountManagementPermissionProfilesDirectClient: `${ROUTE_SETTING_ACCOUNT_MANAGEMENT}/permission-profiles/direct-client`,
  accountManagementPermissionProfilesWhiteLabel: `${ROUTE_SETTING_ACCOUNT_MANAGEMENT}/permission-profiles/white-label`,

  // ******records setting*******
  recordsRoot: `${ROUTE_SETTING_ROOT}${ROUTE_RECORDS_ROOT}`,
  listPage: `${ROUTE_SETTING_ROOT}${ROUTE_RECORDS_ROOT}/list-management`,
  labelPage: `${ROUTE_SETTING_ROOT}${ROUTE_RECORDS_ROOT}/label-management`,
  searchListSaved: `${ROUTE_SETTING_ROOT}${ROUTE_RECORDS_ROOT}/saved-search`,
  searchListExport: `${ROUTE_SETTING_ROOT}${ROUTE_RECORDS_ROOT}/exports`,
  searchListExportLegacy: `/search-list/export/:id`,
  crawlRequestPage: `${ROUTE_SETTING_ROOT}${ROUTE_RECORDS_ROOT}/crawl-request`,
  enrichPage: `${ROUTE_ENRICH_ROOT}`,
  enrichReportPage: `${ROUTE_ENRICH_ROOT}/:id`,

  // ******links*******
  link: `${ROUTE_LINK_ROOT}/:id`,
  file: `${ROUTE_FILE_ROOT}/:id`,

  // ******redirect pages*******
  workspaceDeleted: `/workspace-deleted`,
};
